import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'

import { apiErrorMessage } from '@/api/client'
import { auth } from '@/api/endpoints'
import { Alert, Field, Input, Spinner } from '@/components/ui'

export default function ResetPasswordPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const token = params.get('token') ?? ''

  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    setBusy(true)
    try {
      await auth.resetPassword(token, password)
      navigate('/login', { replace: true })
    } catch (err) {
      setError(apiErrorMessage(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 p-4">
      <div className="card w-full max-w-sm p-6">
        <h1 className="mb-5 text-lg font-semibold">{t('auth.resetTitle')}</h1>

        {!token ? (
          <Alert variant="error">Chýba token v odkaze.</Alert>
        ) : (
          <>
            {error ? (
              <div className="mb-4">
                <Alert variant="error">{error}</Alert>
              </div>
            ) : null}
            <form onSubmit={onSubmit} className="space-y-3">
              <Field label={t('auth.newPassword')}>
                <Input
                  type="password"
                  required
                  minLength={6}
                  autoComplete="new-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Field>
              <button type="submit" className="btn-primary w-full justify-center" disabled={busy}>
                {busy ? <Spinner /> : null}
                {t('global.save')}
              </button>
            </form>
          </>
        )}

        <Link to="/login" className="mt-4 block text-center text-sm text-brand-600 hover:underline">
          {t('auth.backToLogin')}
        </Link>
      </div>
    </div>
  )
}
